module.exports = __webpack_public_path__ + "static/media/1_AP_Normal_Z2.154c55e9.png";